import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import i18n from 'shared/lib/i18n';

import WithLink from '../Linkify';

const StyledPhoneContainer = styled(Box)(() => ({
  padding: '1rem 5rem',
  width: '100%',
  position: 'sticky',
  top: 0,
}));

const StyledPhoneBody = styled(Box)(() => ({
  width: '100%',
  paddingBottom: '210%',
  position: 'relative',
  backgroundColor: '#636363',
  borderRadius: '3.6rem',
}));

const StyledPhoneContentContainer = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
}));

const StyledPhoneContentLayout = styled(Box)(() => ({
  top: '5rem',
  right: '1rem',
  bottom: '5rem',
  left: '1rem',
  position: 'absolute',
  backgroundColor: 'white',
}));

const StyledPreviewContent = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '1.4rem',
  overflow: 'auto',
}));

const AnnouncementsPreviewComponent = (props) => {
  const { title, message } = props;
  return (
    <>
      <div>{i18n.t('announcements.messagePreview')}</div>
      <StyledPhoneContainer>
        <StyledPhoneBody>
          <StyledPhoneContentContainer>
            <StyledPhoneContentLayout>
              <StyledPreviewContent>
                <Box
                  sx={{
                    fontWeight: 700,
                    paddingBottom: '2rem',
                    wordBreak: 'break-word',
                  }}
                >
                  {title}
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  <WithLink>{message}</WithLink>
                </Box>
                <Box sx={{ height: '3.5rem', my: '1rem' }}>
                  <Button
                    sx={{ marginTop: '1rem' }}
                    variant="contained"
                    color="primary"
                    disableElevation
                    fullWidth
                  >
                    <Typography component="span" sx={{ fontSize: '1.4rem' }}>
                      {i18n.t('common.ok')}
                    </Typography>
                  </Button>
                </Box>
              </StyledPreviewContent>
            </StyledPhoneContentLayout>
          </StyledPhoneContentContainer>
        </StyledPhoneBody>
      </StyledPhoneContainer>
    </>
  );
};

AnnouncementsPreviewComponent.defaultProps = {
  title: '',
  message: '',
};

AnnouncementsPreviewComponent.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};

export default AnnouncementsPreviewComponent;
